import { Trans } from '@lingui/macro';
import { Loader } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { LocalDocumentChatMessageStatus } from 'app/domains/assistant';
import { DocumentChatMessageRole, DocumentChatMessageStatus, } from 'shared/domains/apollo/generated/types';
import { getAssistantMessageIconByPromptType } from './utils';
import { Container, Text } from './styled';
export function Message(props) {
    const { status, role, type, html, content } = props;
    const message = html && (html === null || html === void 0 ? void 0 : html.length) > 0 ? html : content;
    switch (status) {
        case DocumentChatMessageStatus.Failed:
            return (<Container>
          <Falcon icon="circle-exclamation" $color="assistant.500"/>
          <Text $assistantColor={role === DocumentChatMessageRole.Assistant}>
            <Trans comment="Document assistant reply when there was an error processing the request">
              There was an error processing your request. Please, try again.
            </Trans>
          </Text>
        </Container>);
        case LocalDocumentChatMessageStatus.Preflight:
            return (<Container>
          <Text $assistantColor>
            <Loader />
          </Text>
        </Container>);
        case DocumentChatMessageStatus.Pending:
            return (<Container $marginTop={role === DocumentChatMessageRole.User}>
          {getAssistantMessageIconByPromptType(type)}
          <Text $assistantColor={role === DocumentChatMessageRole.Assistant}>
            {message !== null && message !== void 0 ? message : <Loader />}
          </Text>
        </Container>);
        default:
            return (message && (<Container $marginTop={role === DocumentChatMessageRole.User}>
            {getAssistantMessageIconByPromptType(type)}
            <Text $assistantColor={role === DocumentChatMessageRole.Assistant}>{message}</Text>
          </Container>));
    }
}
